import { Pressable, StyleSheet } from "react-native";
import { Icon, Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";

export type Citation = {
	id: string;
	title: string;
	url?: string;
};

type CitationCardProps = {
	citation: Citation;
	onPress?: (citation: Citation) => void;
};

const CitationCard = ({ citation, onPress }: CitationCardProps) => {
	const theme = useAppTheme();

	return (
		<Pressable
			onPress={() => onPress?.(citation)}
			accessibilityRole="button"
			accessibilityLabel={`Citation: ${citation.title}`}
			style={[
				styles.container,
				{
					backgroundColor: theme.colors.surfaceVariant,
				},
			]}
		>
			<Text
				variant="labelLarge"
				numberOfLines={2}
				style={{ color: theme.colors.onSurface }}
			>
				{citation.title}
			</Text>
			{citation.url && (
				<Box flexDirection="row" alignItems="center" gap={4}>
					<Icon source="web" size={16} color={theme.colors.onSurfaceVariant} />
					<Text
						variant="labelSmall"
						numberOfLines={1}
						style={[styles.urlText, { color: theme.colors.onSurfaceVariant }]}
					>
						{citation.url.replace(/^https?:\/\/(www\.)?/, "")}
					</Text>
				</Box>
			)}
		</Pressable>
	);
};

const styles = StyleSheet.create({
	container: {
		width: 224,
		padding: 12,
		borderRadius: 12,
		gap: 4,
	},
	urlText: {
		flex: 1,
	},
});

export default CitationCard;
